export const loadingTypes = {
    MULTIPLE_SAVE: {
        lottieUrl: "https://lottie.host/63588eac-fd8b-4752-ac35-220b51c7fa70/MFs2DKdkSc.lottie",
        style: {
            icon: "w-[100%] sm:w-[700px] lg:w-[800px] max-w-[800px] h-auto",
            text: "bottom-12 sm:bottom-16"
        }
    },
    SAVE: {
        lottieUrl: "https://lottie.host/3741b07c-1e62-4b27-b90f-e4898cb55a07/pAUkGAuzwk.lottie",
        style: {
            icon: "w-[100%] sm:w-[350px] lg:w-[400px] max-w-[400px] h-auto",
            text: "bottom-10 sm:bottom-6"
        }
    },
    DOWNLOAD: {
        lottieUrl: "https://lottie.host/6ce47a06-0547-41a1-a0e6-3b167c983a1f/8YSSDRsxsD.lottie",
        style: {
            icon: "w-[100%] sm:w-[350px] lg:w-[400px] max-w-[400px] h-auto",
            text: "bottom-10 sm:bottom-6"
        }
    },
    UPDATE: {
        lottieUrl: "https://lottie.host/453baa5f-ae92-481c-ab90-5f6bf74911fe/JdE1GffEHD.lottie",
        style: {
            icon: "w-[100%] sm:w-[350px] lg:w-[400px] max-w-[400px] h-auto",
            text: "bottom-10 sm:bottom-6"
        }
    }
}
